import { STICKY_NOTES_COLORS } from '@components/ArtBoard/StickyNotes/constants'
import {
  ColorSwatch,
  TinyDropdownMenu,
  Toolbar,
} from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { dotColor } from '../../constants'

const Content: React.FC = () => (
  <TinyDropdownMenu.Grid columns={STICKY_NOTES_COLORS.length}>
    {STICKY_NOTES_COLORS.map((color) => (
      <TinyDropdownMenu.IconOption id={color} key={color}>
        <ColorSwatch color={dotColor(color)} />
      </TinyDropdownMenu.IconOption>
    ))}
  </TinyDropdownMenu.Grid>
)

interface TriggerProps {
  color: string
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ color }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    return (
      <Toolbar.ColorButton
        active={active}
        color={dotColor(color)}
        onClick={toggle}
        ref={ref}
        tooltip="Color"
      />
    )
  }
)

interface Props {
  color: string
}

export const ColorMenu: React.FC<Props> = ({ color }) => {
  const { onClick } = Toolbar.useToolbarClick('color')

  return (
    <TinyDropdownMenu.Root
      active={[color]}
      content={Content}
      onClick={onClick}
      width="fit"
    >
      <Trigger color={color} />
    </TinyDropdownMenu.Root>
  )
}
